import { Component, Prop, Vue } from 'vue-property-decorator';

import {
  getNgAreaMeasure,
  getNgAreaSurfaceMeasure,
  getNgDistanceMeasure,
  getNgSurfaceDistanceMeasure,
} from '../../utils/cesiumExtendsWrapper';

import type { NgwMap } from '@nextgis/ngw-map';
import type { Viewer } from 'cesium';

@Component({
  components: {},
})
export default class MeasureControl extends Vue {
  @Prop({ type: Object }) readonly ngwMap!: NgwMap<Viewer>;

  activeMeasure: any | null = null;
  activeMeasureOngoing: boolean = false;

  measureResult: any | null = null;
  measureResultUnits: string = '';

  get viewer() {
    if (!this.ngwMap?.mapAdapter.map) {
      throw new Error('unreachable');
    }
    return this.ngwMap.mapAdapter.map;
  }

  measureDistanceStart() {
    const measure = getNgDistanceMeasure(this.viewer, {
      ngOnMeasureComplete: (val: any) => {
        this.measureResult = val.value;
        this.measureResultUnits = val.units;
      },
    });
    this.activeMeasure = measure;
    this.activeMeasure.start();
    this.activeMeasureOngoing = true;
    console.log('this.activeMeasure', this.activeMeasure);
  }

  measureSurfaceDistanceStart() {
    const measure = getNgSurfaceDistanceMeasure(this.viewer, {
      ngOnMeasureComplete: (val: any) => {
        this.measureResult = val.value;
        this.measureResultUnits = val.units;
      },
    });
    this.activeMeasure = measure;
    this.activeMeasure.start();
    this.activeMeasureOngoing = true;
  }

  measureAreaStart() {
    const measure = getNgAreaMeasure(this.viewer, {
      ngOnMeasureComplete: (val: any) => {
        this.measureResult = val.value;
        this.measureResultUnits = val.units;
      },
    });
    this.activeMeasure = measure;
    this.activeMeasure.start();
    this.activeMeasureOngoing = true;
  }

  measureAreaSurfaceStart() {
    const measure = getNgAreaSurfaceMeasure(this.viewer, {
      ngOnMeasureComplete: (val: any) => {
        this.measureResult = val.value;
        this.measureResultUnits = val.units;
      },
    });
    this.activeMeasure = measure;
    this.activeMeasure.start();
    this.activeMeasureOngoing = true;
  }

  measureEnd() {
    this.activeMeasure.end();
    this.activeMeasure = null;
    this.measureResult = null;
    this.measureResultUnits = '';
    console.log('this.activeMeasure', this.activeMeasure);
    this.activeMeasureOngoing = false;
  }
}
